import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import * as forgotPasswordFormActions from '../../../store/actions/forgot-password-actions';
import * as formStateHelpers from '../helpers/form-helpers/form-state-helper';
import * as formFieldDisplayHelpers from '../helpers/form-helpers/form-field-display-helpers';
import initialState from '../helpers/form-helpers/initial-state';
import SSOFormFooter from '../../common/utility/SSOFormFooter';
import FormSpinner from '../../common/utility/FormSpinner';
import FormMessage from '../../common/utility/FormMessage';
import { isEmpty } from '../../utils/obj-utils';
import FormBuilder from '../helpers/form-builder';

class ForgotPasswordForm extends Component {
    constructor(props) {
        super(props);
        this.state = initialState.forgotPasswordFormState;

        this.handleSubmit = this.handleSubmit.bind(this);
        this.displayForgotPasswordForm = this.displayForgotPasswordForm.bind(this);
        this.displayForm = this.displayForm.bind(this);
        this.handleValidationResult = this.handleValidationResult.bind(this);
        this.submitForgotPasswordData = this.submitForgotPasswordData.bind(this);
        this.resetForm = this.resetForm.bind(this);

        this.loadForgotPasswordFormData();
    }

    loadForgotPasswordFormData() {
        const { actions, forgotPasswordFormData } = this.props;

        if (!isEmpty(forgotPasswordFormData)) {
            return;
        }

        actions.loadSSOForgotPasswordFormData();
    }

    componentWillReceiveProps(nextProps) {
        const {
            isForgotPasswordSuccessful,
            loading
        } = nextProps;

        if (!loading && isForgotPasswordSuccessful) {
            this.setState(formStateHelpers.updateProcessingState(false));
            return;
        }

        if (!loading && !isForgotPasswordSuccessful) {
            this.setState(formStateHelpers.updateProcessingState(false));
        }
    }

    componentWillUnmount() {
        this.resetForm();
    }

    resetForm() {
        const { actions } = this.props;
        this.setState(initialState.forgotPasswordFormState);
        actions.resetForgotPasswordFormState();
    }

    handleSubmit(event) {
        event.preventDefault();
        const { forgotPasswordFormData } = this.props;
        this.setState(formStateHelpers.handleFormValidation(forgotPasswordFormData), this.handleValidationResult);
    }

    handleValidationResult() {
        if (this.state.formHasErrors) {
            return;
        }

        this.setState(formStateHelpers.updateProcessingState(true), this.submitForgotPasswordData);
    }

    submitForgotPasswordData() {
        const { actions, forgotPasswordFormData } = this.props;
        const { emailAddress } = this.state;
        const { callBackUrl, ssoDomain } = forgotPasswordFormData;
        const actionSuccessText = forgotPasswordFormData.actionSuccessText || formMessageConstants.forgotPasswordSuccessText;

        actions.handleUserForgotPassword({ emailAddress, actionSuccessText, website: ssoDomain }, callBackUrl);
    }

    displayForm() {
        const {
            isForgotPasswordSuccessful,
            forgotPasswordMessages,
            onSignIn,
            forgotPasswordFormData
        } = this.props;

        if (isEmpty(forgotPasswordFormData)) {
            return null;
        }

        return (<form onSubmit={this.handleSubmit}>
            <FormMessage
                isSuccessMessage={isForgotPasswordSuccessful}
                messages={forgotPasswordMessages}></FormMessage>
            {this.displayForgotPasswordForm()}
            <SSOFormFooter
                onSubmit={this.handleSubmit}
                footerButtonText={formMessageConstants.reset}
                linkCallBackUrl={onSignIn}
                footerLinkText={`${formMessageConstants.rememberPassword} ${formMessageConstants.signInHere}`}>
            </SSOFormFooter>
        </form>);
    }

    displayForgotPasswordForm() {
        const { forgotPasswordFormData } = this.props;

        return FormBuilder({
            formData: forgotPasswordFormData,
            formReferences: this.formReferences,
            handleFieldChange: (event) => { this.setState(formStateHelpers.handleFieldChangeWithValidation(event.target)); },
            handleFieldValidState: (fieldName) => { const { errors } = this.state; return formFieldDisplayHelpers.handleFieldValidState(fieldName, errors); },
        });
    }

    render() {
        const { isProcessing } = this.state;
        const { loading } = this.props;
        return (
            <div className='modal__content form-container'>
                <div className='auto-ph-md auto-p-md constrain-tablet ff-founders fs-14'>
                    <br />
                    {(isProcessing || loading) ? <FormSpinner>/</FormSpinner> : null}
                    {this.displayForm()}
                </div >
            </div >
        );
    }
}

ForgotPasswordForm.propTypes = {
    loading: PropTypes.bool.isRequired,
    onSignIn: PropTypes.func.isRequired,
    forgotPasswordFormData: PropTypes.object
};

function mapStateToProps(state) {
    return {
        forgotPasswordFormData: state.forgotPasswordForm.forgotPasswordFormData,
        isForgotPasswordSuccessful: state.forgotPasswordForm.isForgotPasswordSuccessful,
        forgotPasswordMessages: state.forgotPasswordForm.forgotPasswordMessages,
        loading: state.apiStatus.apiCallsInProgress > 0
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            loadSSOForgotPasswordFormData: bindActionCreators(forgotPasswordFormActions.loadSSOForgotPasswordFormData, dispatch),
            handleUserForgotPassword: bindActionCreators(forgotPasswordFormActions.handleUserForgotPassword, dispatch),
            resetForgotPasswordFormState: bindActionCreators(forgotPasswordFormActions.resetForgotPasswordFormState, dispatch),
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ForgotPasswordForm);
